import styled from 'styled-components';
import { device } from "../../themes/Breakpoints";

export const AddPLayerWrapper = styled.div``;

export const AddPLayerModal = styled.div`
	width: 100%;
	max-width: 710px;
	margin: 0 auto;
  @media ${device.tablet}{
    max-width: 600px;
  }
   @media ${device.mobileL}{
     max-width: 340px;
   }
  @media ${device.mobileM}{
    max-width:280px;
  }
  @media ${device.mobileS}{
    max-width: 220px;
  }
`;

export const AddPLayerModalWrapper = styled.div`
	max-width: 950px;
	width: 100%;
	border-radius: 10px;
	background: #fff;
	padding: 32px;
	text-align: left;
	position: relative;
	max-height: 600px;
	overflow-y: auto;

	.closeModal {
		position: absolute;
		top: 27px;
		right: 30px;
		font-size: 18px;
		color: rgb(14, 17, 24);
		font-family: 'Saira Semi Condensed';
		font-weight: 700;
		cursor: pointer;
	}
  @media only screen and (max-width: 1249px) {
    padding: 24px;
  }
  @media only screen and (max-width: 767px) {
    padding: 12px 2px;
  }
  @media ${device.tabletL} {
    max-width: 850px;
  }
  @media ${device.tablet}{
    max-width: 700px;
  }
  @media ${device.mobileL}{
    max-width: 400px;
    .closeModal {
      top: 18px;
    }
  }
  @media ${device.mobileM}{
    max-width: 350px;
    .closeModal {
      top: 18px;
    }
  }
  @media ${device.mobileS}{
    max-width: 280px;
    .closeModal {
      top: 18px;
    }
  }
`;



// export const CustomSelectWrapper = styled.div`
//   width: 100%;
//   max-width: ${({ customWidth }) => customWidth || '345px'}; /* Use customWidth prop */
//   position: relative;
//
//   .custom-select {
//     width: 100%;
//     max-width: ${({ customWidth }) => customWidth || '345px'}; /* Apply customWidth to the dropdown */
//   }
//
//   @media (max-width: 480px) {
//     max-width: 100%; /* Make it full width on small screens */
//   }
// `;

  export const AddPlayerTitle = styled.h2`
	font-size: 36px;
	font-weight: 500;
	color: #0e1118;
	font-family: 'Saira Semi Condensed';
	line-height: 41.6px;
	margin-bottom: 20px;
  @media only screen and (max-width: 1249px) {
    font-size: 28px;
    line-height:34px
  }
`;

export const AddPLayerForm = styled.div`
	width: 100%;
	margin-top: 20px;
`;

export const InputWrap = styled.div`
	width: 100%;
	margin-bottom: 20px;

	input {
		font-family: 'Saira Semi Condensed', sans-serif;
		font-weight: 400;
		width: 100%;
		padding: 9px 16px;
		background: #ffffff;
		border: 1px solid #afb4b9;
		border-radius: 4px;
		font-size: 16px;
		line-height: 27px;
		min-height: 56px;

		::placeholder {
			color: #3e464f;
			font-weight: 400;
			font-style: normal;
			font-size: 16px;
			line-height: 27px;
		}

		:focus-visible {
			outline-color: #1976d2;
		}
	}
  @media only screen and (max-width: 1249px) {
    margin-bottom: 8px;
  }
  @media only screen and (max-width: 767px) {
    input{
      padding: 9px
    }
  }
`;

export const AddPlayerBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	position: relative;
  @media only screen and (max-width: 1249px) {
    gap: 8px;
  }
`;

export const RemoveButton = styled.div`
	position: absolute;
	top: -10px;
	right: -40px;
	cursor: pointer;
	color: #ff1717;
	font-size: 20px;
      @media ${device.mobileL}{
        right: -25px;
      }
      @media ${device.mobileM}{
        right: -25px;
      }
      @media ${device.mobileS}{
        right: -25px;
      }
`;

export const SelectWrapContainer = styled.div`
	display: flex;
	gap: 20px;
	margin-bottom: 20px;
  @media only screen and (max-width: 899px) {
   flex-direction:column;
  }
`;

export const SelectWrap = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

export const StyledButton = styled.button`
	background-color: #004ea3;
	color: white;
	border: none;
	padding: 10px 20px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 16px;
	font-family: 'Saira Semi Condensed', sans-serif;
	font-weight: 500;
	height: 46px;
	&:hover {
		background-color: #115293;
	}

	&:not(:last-child) {
		margin-right: 10px;
	}
	&.svBtn {
		margin-top: 60px;
	}
  //@media only screen and (max-width: 767px) {
  //    padding: 9px
  //}
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
`;
